// extracted by mini-css-extract-plugin
export default {"survey_1":"index-module_survey_1_ix-MF","surveyList":"index-module_surveyList_jmfhT","surveyItem":"index-module_surveyItem_jHabJ","imagePart":"index-module_imagePart_-C9wP"};